import { useCallback } from 'react';
import { PhoneInput as DesignPhoneInput, type PhoneInputProps as DesignPhoneInputProps, type ContactInputValidator } from '@v0y4ge/jrni-ui';
import { validatePhoneInput } from '../contact-validation';
export type { ContactInputValidator } from '@v0y4ge/jrni-ui';
export interface PhoneInputProps extends Omit<DesignPhoneInputProps, 'validate'> { validate?: ContactInputValidator }
/** Bind the shared design control to the canonical contact contract. */
export function PhoneInput({ validate = validatePhoneInput, ...props }: PhoneInputProps) {
  const check = useCallback((value: string) => props.required && !value.trim() ? 'Enter a phone number.' : validate(value), [props.required, validate]);
  return <DesignPhoneInput {...props} validate={check} />;
}
